<template>
  <label
    class="fox-radio-button-wrapper"
    :class="{
      'fox-radio-button-wrapper__inline': inline,
      'fox-radio-button-wrapper__as-button': button,
      'fox-radio-button-wrapper__as-radio': !button,
    }"
  >
    <template v-if="!button">
      <div v-if="label || $slots.label">
        <div v-if="label && !$slots.label" class="fox-radio-button-label">{{ label }}</div>
        <slot v-else-if="$slots.label" name="label" />
      </div>
      <input
        class="fox-radio-button"
        type="radio"
        :name="name"
        :checked="isSelected ? 'checked' : ''"
        :disabled="disabled"
        @change="onChange"
      >
      <div class="control-indicator" />
    </template>

    <fox-button
      v-else
      :disabled="disabled"
      :size="buttonSize"
      :variant="selectedBtnVariant"
      @click.native="onBtnBoxClick"
    >
      <span v-if="label && !$slots.label">{{ label }}</span>
      <slot v-else-if="$slots.label" name="label" />
    </fox-button>
  </label>
</template>

<script>
import FoxButton from '@/UIKit/components/button/FoxButton'
export default {
  name: 'FoxRadioButton',
  components: { FoxButton },
  props: {
    value: {
      required: false,
      default: false,
      type: [Boolean, String, Number]
    },
    name: {
      required: false,
      default: '',
      type: String
    },
    disabled: Boolean,
    inline: Boolean,
    label: {
      required: false,
      default: '',
      type: String
    },
    selected: {
      required: false,
      default: true,
      type: [Boolean, String, Number]
    },
    notSelected: {
      required: false,
      default: false,
      type: [Boolean, String, Number]
    },
    button: Boolean,
    buttonVariant: {
      required: false,
      default: 'primary',
      type: String
    },
    notSelectedButtonVariant: {
      required: false,
      default: 'outline',
      type: String
    },
    buttonSize: {
      required: false,
      default: 'lg',
      type: String
    }
  },
  computed: {
    vModel: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    isSelected () {
      return this.vModel === this.selected
    },
    selectedBtnVariant () {
      return this.isSelected ? this.buttonVariant : this.notSelectedButtonVariant
    }
  },
  methods: {
    onBtnBoxClick () {
      if (!this.button) {
        return false
      }

      if (!this.isSelected) {
        this.vModel = this.selected
      }
    },
    onChange ($event) {
      this.vModel = $event.target.checked ? this.selected : this.notSelected
    }
  }
}
</script>

<style scoped lang="sass">
@import '../../scss/components/radio-input'
</style>
